import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCPMFTrackingForecastSubpage } from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import { useListTrackingForecastPreferencesQuery } from 'services/api/Meteorology/Fields/TrackingForecast/DetailedView';
import { SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Fields/TrackingForecast/DetailedView';

export default function useListPreferences() {
  const subpage = useSelector(selectCPMFTrackingForecastSubpage);
  const submenu = SUBPAGE_SUBMENU_OPTIONS[subpage];

  const { data, error, isLoading } = useListTrackingForecastPreferencesQuery();

  const preferences = useMemo(() => {
    if (!data || !submenu) {
      return [];
    }

    return data.filter((preference) => preference.submenu === submenu);
  }, [data, submenu]);

  return {
    preferences,
    isLoading,
    error,
  };
}
